import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Site } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createSiteApi, siteKeys } from '../api';
import type { UpdateSiteParams } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useUpdateSite(siteId: string): UseMutationResult<Site, Error, UpdateSiteParams> {
  const client = useApiClient('admin-auth');
  const api = createSiteApi(client);
  const queryClient = useQueryClient();

  return useMutation<Site, Error, UpdateSiteParams>({
    mutationFn: (params: UpdateSiteParams) => api.updateSite(siteId, params),
    ...createMutationCallbacks({
      invalidateKeys: [siteKeys.all],
      queryClient,
    }),
  });
}
